export enum TourStepEnum {
  AccountSettings,
  Sidebar,
  HomeDashboard,
  Congratulations,
}
